import script from "./PortfolioTradeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioTradeModal.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioTradeModal.vue?vue&type=style&index=0&id=77e258d9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e258d9"]])

export default __exports__